import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InvalidProfileModalComponent } from './invalid-profile-modal/invalid-profile-modal.component';

@NgModule({
  imports: [CommonModule],
  declarations: [InvalidProfileModalComponent],
  exports: [InvalidProfileModalComponent],
})
export class ModalModule {}
